<ng-template #categoryNameModal>
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()" data-testid="report-category-name-modal-close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <label for="divisionId">Division</label>
    <select id="divisionId" class="form-control" [(ngModel)]="divisionId" [disabled]="parentCategoryId" data-testid="report-category-name-modal-division">
      <option [ngValue]="null">Select division...</option>
      <option *ngFor="let division of divisionList" [ngValue]="division.id">
        {{ division.divisionName }}
      </option>
    </select>
    <div class="form-group">
      <label for="categoryId">Parent Category</label>
      <select
        id="categoryId"
        class="form-control"
        [(ngModel)]="parentCategoryId"
        (change)="onParentCategoryChange()" data-testid="report-category-name-modal-parent-category">
        <option [ngValue]="null" >-- Root Category --</option>
        <option
          *ngFor="let category of categoryList"
          [ngValue]="category.id">
          {{ category.name }}
        </option>
      </select>
    </div>
    <div class="form-group">  
      <label for="categoryName">Category Name</label>
      <input
        id="categoryName"
        type="text"
        class="form-control"
        maxlength="250"
        [(ngModel)]="categoryName"
        placeholder="Enter category name" data-testid="report-category-name-modal-category-name"/>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()" data-testid="report-category-name-modal-cancel">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="!categoryName || !categoryName.trim() || isSaving" (click)="onSave()" data-testid="report-category-name-modal-save">
      Save
    </button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/report-type-editor/report-category-name-modal/report-category-name-modal.component.html